<template>
  <div class="ui-drawer">
    <div class="drawer-wrap">
      <!-- <img
        @click="switchDrawer"
        :src="`${rootUrl}/img/takumi-hirano_001.png`"
        class="drawer-button"
        alt="メニュー"
      /> -->
      <div
        class="btn-trigger btn05"
        @click="hamburgerSet"
        :class="{
          active: active === true,
          '': active === false,
        }"
      >
        <!-- <span></span> -->
        <span></span>
        <span></span>
      </div>
      <div></div>
      <div
        id="drawer-menu"
        class="drawer-menu"
        :class="{
          'open-drawer': openDrawer === true,
          'close-drawer': openDrawer === false,
        }"
      >
        <div class="drawer-header"></div>
        <div @click="hamburgerSet" class="drawer-body">
          <div class="drawer-item">
            <router-link to="/">トップ</router-link>
          </div>
          <div class="drawer-item">
            <router-link to="/pg">プログラマー<span class="kakko">(経験者)</span></router-link>
          </div>
          <div class="drawer-item">
            <router-link to="/pg01">プログラマー<span class="kakko">(未経験者)</span></router-link>
          </div>
          <div class="drawer-item">
            <router-link to="/web">ウェブサイト制作<span class="kakko">(経験者)</span></router-link>
          </div>
          <div class="drawer-item">
            <router-link to="/web01">ウェブサイト制作<span class="kakko">(未経験者)</span></router-link>
          </div>
          <div class="drawer-item">
            <router-link to="/web-design">ウェブデザイナー</router-link>
          </div>
          <div class="drawer-item">
            <router-link to="/design">デザイナー</router-link>
          </div>
          <div class="drawer-item">
            <router-link to="/marketing">マーケティングサポート</router-link>
          </div>
          <div class="drawer-item">
            <router-link to="/ad">広告運用サポート</router-link>
          </div>
          <div class="drawer-item">
            <router-link to="/keiri">経理</router-link>
          </div>
          <div class="drawer-item">
            <router-link to="/jimu">事務</router-link>
          </div>
          <div class="drawer-item">
            <router-link to="/" v-scroll-to="`#top-contact`">お問い合わせ</router-link>
          </div>
          <div class="drawer-item">
            <a href="https://greathelp.co.jp/" target="_blank" rel="noopener noreferrer">会社情報</a>
          </div>
        </div>
      </div>
    </div>
    <div
      @click="hamburgerSet"
      class="back-gray"
      :class="{ 'back-gray-show': openDrawer === true }"
    ></div>
  </div>
</template>

<script>
export default {
  name: "UiDrawer",
  data() {
    return {
      openDrawer: false,
      active: false,
    };
  },
  computed: {
    rootUrl() {
      return this.$store.getters.rootUrl;
      // return this.$store.getters.rt;
    },
  },
  watch: {
    openDrawer(newVal) {
      if (newVal) {
        document.body.style.overflow = "hidden"; // bodyのスクロールを無効化
        const drawerMenu = document.getElementById("drawer-menu");
        if (drawerMenu) {
          drawerMenu.style.overflowY = "scroll"; // #drawer-menuの縦スクロールを有効化
        }
      } else {
        document.body.style.overflow = "auto"; // bodyのスクロールを有効化
        const drawerMenu = document.getElementById("drawer-menu");
        if (drawerMenu) {
          drawerMenu.style.overflowY = "hidden"; // #drawer-menuのスクロールを無効化
        }
      }
    },
  },
  methods: {
    switchDrawer() {
      this.openDrawer = this.openDrawer === false ? true : false;
    },
    hamburgerButton() {
      this.active = this.active === false ? true : false;
    },
    hamburgerSet() {
      this.switchDrawer();
      this.hamburgerButton();
    },
  },
};
</script>

<style lang="scss" scoped>
$width: 280px;
.drawer-wrap {
  .drawer-button {
    width: 50px;
    cursor: pointer;
  }
  .drawer-menu {
    transition: all 1s 0s ease;
    position: fixed;
    top: 0;
    background-color: rgba(130, 130, 130, 0.8);
    // padding: 5px 10px 50px 10px;//普通のリストは復活
    box-sizing: border-box;
    z-index: 999;
    width: $width;
    height: 100vh;

    .drawer-body {
      // background-color: var(--beige);
      padding-top: 50px;
      padding-bottom: 150px;
      .drawer-item {
        text-align: initial;
        transition: all 1s;
        padding: 12px 10px;
        // background-color: white;
        transition: all 0.5s; //普通のリストは消す
        position: relative; //普通のリストは消す
        z-index: 2; //普通のリストは消す
        &:hover {
          cursor: pointer;
        }
        span {
          margin-left: 10px;
        }

        a {
          width: 100%;
        }

        a,
        span {
          text-decoration: none;
          color: white;
          position: relative;
          display: inline-block;
          &::after {
            position: absolute;
            bottom: -5px;
            left: 0;
            content: "";
            width: 100%;
            height: 2px;
            background: white;
            transform: scale(0, 1);
            transform-origin: left top;
            transition: transform 0.5s;
          }
          &:hover::after {
            transform: scale(1, 1);
          }
        }
      }
    }
  }
}
.open-drawer {
  // display: initial;
  opacity: 1;
  transform: translateX(-$width);
  right: -$width;
}
.close-drawer {
  // display: none;
  opacity: 0;
  transition: opacity 3s linear 2s;
  transform: translateX($width);
  right: -$width;
}

.back-gray {
  display: none;
  position: fixed;
  z-index: 998;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background-color: white;
  opacity: 0.5;
}
.back-gray-show {
  display: initial;
}

.btn-trigger {
  position: relative;
  width: 38px;
  height: 44px;
  cursor: pointer;
  z-index: 1000;
  @media screen and (max-width: 1024px) {
    //  width: 40px;
    //  height: 35px;
  }
}
.btn-trigger span {
  position: absolute;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: var(--main);
  border-radius: 3px;
}
.btn-trigger,
.btn-trigger span {
  display: inline-block;
  transition: all 0.5s;
  box-sizing: border-box;
}
.btn-trigger span:nth-of-type(1) {
  top: 20px;
  left: 10px;
}
.btn-trigger span:nth-of-type(2) {
  top: 30px;
  // top: 10px;
}

.btn-trigger span:nth-of-type(1) {
  animation: menu-bar01 0.75s forwards;
}
@keyframes menu-bar01 {
  0% {
    transform: translateY(20px) rotate(45deg);
  }
  50% {
    transform: translateY(20px) rotate(0);
  }
  100% {
    transform: translateY(0) rotate(0);
  }
}

.btn-trigger.active span:nth-of-type(1) {
  animation: active-menu-bar01 0.75s forwards;
  background-color: white;
}
@keyframes active-menu-bar01 {
  0% {
    transform: translateY(0) rotate(0);
  }
  50% {
    transform: translateY(0px) rotate(0);
  }
  100% {
    transform: translateY(3px) translateX(-10px) rotate(45deg);
  }
}
.btn-trigger.active span:nth-of-type(2) {
  background-color: white;
  animation: active-menu-bar03 0.75s forwards;
}

@keyframes active-menu-bar03 {
  0% {
    transform: translateY(0) rotate(0);
  }
  50% {
    transform: translateY(-10px) rotate(0);
  }
  100% {
    transform: translateY(-8px) rotate(-45deg);
  }
}
.kakko{
  font-size: 14px;
  margin-left: 5px;
}
</style>